import { Box, Button, Paper, Stack, Typography } from '@mui/material';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import { useNavigate } from 'react-router-dom';

export function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 2,
        py: 6,
      }}
    >
      <Paper
        sx={{
          maxWidth: 520,
          width: '100%',
          p: { xs: 3, sm: 4 },
          textAlign: 'center',
          background: 'linear-gradient(165deg, rgba(91,156,248,0.1) 0%, rgba(12,21,36,0.95) 55%)',
        }}
      >
        <Typography variant="overline" sx={{ letterSpacing: 4, opacity: 0.7, fontWeight: 700 }}>
          x-IAM
        </Typography>
        <Typography variant="h3" sx={{ fontWeight: 800, mt: 1.5, letterSpacing: -0.04 }}>
          404
        </Typography>
        <Typography variant="h6" sx={{ fontWeight: 700, mt: 1, opacity: 0.92 }}>
          This view is not available
        </Typography>
        <Typography variant="body2" sx={{ opacity: 0.75, mt: 2, lineHeight: 1.65 }}>
          The route does not exist in the superadmin console, or it has not been shipped in this build
          yet.
        </Typography>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5} justifyContent="center" sx={{ mt: 3.5 }}>
          <Button size="large" startIcon={<HomeOutlinedIcon />} onClick={() => navigate('/')}>
            Console home
          </Button>
          <Button size="large" variant="outlined" color="inherit" startIcon={<ArrowBackOutlinedIcon />} onClick={() => navigate(-1)}>
            Back
          </Button>
        </Stack>
      </Paper>
    </Box>
  );
}
